import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DebugUtils } from "abweb/utils/DebugUtils";
/**
 * Manage a map of ResourceBundles partitioned by namespace (aka module name).  Supports
 * namespace keys of the form 'namespace:key', such as abweb:MY_RESOURCE.  Also supports processing
 * 'override' resource bundles to override specific resources in the (module) Resource Bundles.
 */
export class NamespaceManager {
  constructor(modules, overrides) {
    // Ordered list of locales, each with its own corresponding bundle
    _defineProperty(this, "moduleBundles", new Map());
    this.addResourceBundle(...modules);
    this.applyOverrides(...overrides);
  }
  clearResourceBundles() {
    this.moduleBundles.clear();
  }
  addResourceBundle(...rbs) {
    for (const rb of rbs) {
      if (this.moduleBundles.has(rb.namespace)) {
        throw new Error("NamespaceManager already has a module for namespace: " + rb.namespace);
      }
      this.moduleBundles.set(rb.namespace, rb);
    }
  }
  applyOverrides(...overrideRBs) {
    for (const overrideRB of overrideRBs) {
      for (const lb of overrideRB.localeBundles) {
        for (const nsKey in lb.bundle) {
          // The keys in an override resource bundle will be namespace qualified, so parse to get ns and key components
          const nsKeyParsed = this.parseNamespaceKey(nsKey);
          // Looks up normal module (non-override) via the nsKeyParsed.ns value
          const rb = this.getResourceBundleOrError(nsKeyParsed.resourceBundleKey);
          // Now replace the resource in the normal module with the override value provided by the override resource bundle
          rb.setOverrideResource(lb.locale, nsKeyParsed.msgKey, lb.bundle[nsKey]);
        }
      }
    }
  }

  /**
   * @return null if key not found.
   * @throws error if nsKey does not contain namespace (e.g., abweb:MY_KEY),
   * or if there is no resource bundled defined for the namespace
   */
  getResource(resourceBundleKey, msgKey) {
    // let nsKeyParsed = this.parseNamespaceKey(nsKey);
    const rb = this.getResourceBundleOrError(resourceBundleKey);
    return rb.getResource(msgKey);
  }
  getResourceBundleOrError(resourceBundleKey) {
    const rb = this.moduleBundles.get(resourceBundleKey);
    if (rb == null) {
      DebugUtils.logAndThrowError("Resource bundle for resourceBundleKey='" + resourceBundleKey + "' was not found.");
    }
    return rb;
  }
  parseNamespaceKey(nsKey) {
    const nsIndex = nsKey.indexOf(":");
    if (nsIndex <= 0) {
      DebugUtils.logAndThrowError("Unable to parse module name from resource key '" + nsKey + "'.");
    }
    return {
      resourceBundleKey: nsKey.substr(0, nsIndex),
      msgKey: nsKey.substr(nsIndex + 1),
      nsKey: nsKey
    };
  }
}
//# sourceMappingURL=NamespaceManager.js.map
